import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-login-successful',
  templateUrl: './login-successful.component.html',
  styleUrls: ['./login-successful.component.css']
})
export class LoginSuccessfulComponent implements OnInit {
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  constructor() { }

  ngOnInit() {
    console.log('ngOnInit called'); // Add a console log to verify if ngOnInit is being called
    setTimeout(() => {
      this.closeModal.emit();
    }, 3000);
  }

}
